<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="discLdgMode === 'New'">mdi-plus</v-icon>
          <v-icon v-else-if="discLdgMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-else-if="discLdgMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newDiscLdg">Create New Discount / Loading</v-toolbar-title>
          <v-toolbar-title v-else-if="discLdgMode === 'Review'">Edit Discount / Loading</v-toolbar-title>
          <v-toolbar-title v-else-if="discLdgMode === 'Query'">Query Discount / Loading</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newDiscLdg">
                <v-text-field
                  v-model="discLdgForm.discLdg"
                  :label="labels.discLdg"
                  :error-messages="errors.collect('discLdg')"
                  data-vv-name="discLdg"
                  :data-vv-as="labels.discLdg"
                  v-validate="'required|param|max:2'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.discLdg }}</v-subheader>
                <div class="queryValue">{{ discLdgForm.discLdg }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :readonly="discLdgMode === 'Query'"
                  v-model="discLdgForm.discLdgDesc"
                  :label="labels.discLdgDesc"
                  :error-messages="errors.collect('discLdgDesc')"
                  data-vv-name="discLdgDesc"
                  :data-vv-as="labels.discLdgDesc"
                  v-validate="'required|entry|max:35'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :readonly="discLdgMode === 'Query'"
                  v-model="discLdgForm.discLdgPct"
                  :label="labels.discLdgPct"
                  :error-messages="errors.collect('discLdgPct')"
                  data-vv-name="discLdgPct"
                  :data-vv-as="labels.discLdgPct"
                  v-validate="'required|entry|max:60|mask_decimal:2'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ discLdgForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(discLdgForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newDiscLdg">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ discLdgForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(discLdgForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-container fluid grid-list-lg v-if="!loading">
          <v-btn class="mr-2 mb-2" color="error" @click="doCancel" :loading="submitting">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn color="primary" v-if="discLdgMode !== 'Query'" class="mb-2" dark @click="doSave" :loading="submitting">
            Save Discount / Loading
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-container>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        discLdg: 'Discount / Loading Type',
        discLdgDesc: 'Description',
        discLdgPct: 'Discount / Loading %',
        createdBy: 'Created By',
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      discLdgForm: {
        discLdg: null,
        discLdgDesc: null,
        discLdgPct: 0,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        modifiedName: null
      },
      newDiscLdg: false,
      loading: false,
      submitting: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      this.loading = true
      const apiURI = this.discLdgMenu.getDiscLdg
      if (apiURI) {
        this.loading = true
        try {
          const expand = { discldg: this.discldg }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.loading = true
            this.discLdgForm.discLdg = data.discLdg.discLdg
            this.discLdgForm.discLdgDesc = data.discLdg.discLdgDesc
            this.discLdgForm.discLdgPct = data.discLdg.discLdgPct
            this.discLdgForm.createdName = data.discLdg.createdName
            this.discLdgForm.createdDate = data.discLdg.createdDate
            this.discLdgForm.modifiedName = data.discLdg.modifiedName
            this.discLdgForm.modifiedDate = data.discLdg.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newDiscLdg) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.discLdgMenu.createDiscLdg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.discLdgForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.discLdgMenu.updateDiscLdg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.discLdgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.$router.push({ name: 'discLdgList' })
    }
  },
  computed: {
    discLdgMenu() {
      return this.$store.state.discLdgParam.menu
    },
    discldg() {
      return this.$route.params.discldg
    },
    discLdgMode() {
      return this.$route.params.discLdgMode
    }
  },
  created() {
    if (this.discldg === 'new') {
      this.newDiscLdg = true
    } else {
      this.doFetch()
    }
  },
  mounted() {},
  mixins: [MessageMixin]
}
</script>
